module.exports = __webpack_public_path__ + "img/loadingPage.92d731e0.gif";